import React, { useState } from 'react';
import { BusinessDetailsScreen } from './screens/BusinessDetailsScreen';
import { BusinessTypeScreen } from './screens/BusinessTypeScreen';
import { RegistrationDateScreen } from './screens/RegistrationDateScreen';
import { OnlinePresenceScreen } from './screens/OnlinePresenceScreen';
import { RegistrationDocumentScreen } from './screens/RegistrationDocumentScreen';
import { RegisteredAddressScreen } from './screens/RegisteredAddressScreen';
import { CorrespondenceAddressScreen } from './screens/CorrespondenceAddressScreen';
import { IncomeTransactionsScreen } from './screens/IncomeTransactionsScreen';
import { BusinessInfoReview } from './screens/BusinessInfoReview';
interface BusinessInfoJourneyProps {
  onComplete: (data: any) => void;
  onExit: () => void;
}
export function BusinessInfoJourney({
  onComplete,
  onExit
}: BusinessInfoJourneyProps) {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    businessName: '',
    tradingName: '',
    mccCode: '',
    companyType: '',
    registrationDate: '',
    website: '',
    socialMedia: '',
    registrationDocument: null as File | null,
    registeredAddress: '',
    registeredCity: '',
    registeredState: '',
    registeredZip: '',
    correspondenceAddress: '',
    correspondenceCity: '',
    correspondenceState: '',
    correspondenceZip: '',
    sameAsRegistered: false,
    annualRevenue: '',
    monthlyTransactions: ''
  });
  const updateField = (field: string, value: any) => {
    setFormData(prev => {
      const newData = {
        ...prev,
        [field]: value
      };
      // Auto-fill correspondence if checkbox is checked
      if (field === 'sameAsRegistered' && value === true) {
        newData.correspondenceAddress = prev.registeredAddress;
        newData.correspondenceCity = prev.registeredCity;
        newData.correspondenceState = prev.registeredState;
        newData.correspondenceZip = prev.registeredZip;
      }
      // If updating registered address and checkbox is checked, sync correspondence
      if (prev.sameAsRegistered && field.startsWith('registered')) {
        const corrField = field.replace('registered', 'correspondence');
        // @ts-ignore - dynamic key access
        newData[corrField] = value;
      }
      return newData;
    });
  };
  const nextStep = () => setStep(prev => prev + 1);
  const prevStep = () => {
    if (step === 0) {
      onExit();
    } else {
      setStep(prev => prev - 1);
    }
  };
  const goToStep = (stepIndex: number) => setStep(stepIndex);
  const handleConfirm = () => {
    onComplete(formData);
  };
  return <div className="h-full" data-id="element-4">
      {step === 0 && <BusinessDetailsScreen businessName={formData.businessName} tradingName={formData.tradingName} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-5" />}

      {step === 1 && <BusinessTypeScreen mccCode={formData.mccCode} companyType={formData.companyType} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-6" />}

      {step === 2 && <RegistrationDateScreen registrationDate={formData.registrationDate} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-7" />}

      {step === 3 && <OnlinePresenceScreen website={formData.website} socialMedia={formData.socialMedia} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-8" />}

      {step === 4 && <RegistrationDocumentScreen registrationDocument={formData.registrationDocument} onChange={file => updateField('registrationDocument', file)} onNext={nextStep} onBack={prevStep} data-id="element-9" />}

      {step === 5 && <RegisteredAddressScreen address={formData.registeredAddress} city={formData.registeredCity} state={formData.registeredState} zipCode={formData.registeredZip} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-10" />}

      {step === 6 && <CorrespondenceAddressScreen address={formData.correspondenceAddress} city={formData.correspondenceCity} state={formData.correspondenceState} zipCode={formData.correspondenceZip} sameAsRegistered={formData.sameAsRegistered} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-11" />}

      {step === 7 && <IncomeTransactionsScreen annualRevenue={formData.annualRevenue} monthlyTransactions={formData.monthlyTransactions} onChange={updateField} onNext={nextStep} onBack={prevStep} data-id="element-12" />}

      {step === 8 && <BusinessInfoReview data={formData} onConfirm={handleConfirm} onBack={prevStep} onEdit={goToStep} data-id="element-13" />}
    </div>;
}